import React from 'react'
import OEIInput from './OEIInput';
import './OEIPopover.css'
import OEICheckBox from './OEICheckBox'
import { EMPTY, FIRSTNAME, LASTNAME } from './Constants';

export default function EditUserPopover(props) {
    const setFirstName = (e) => {
        props.setEditUserData({ ...props.editUserData, firstName: e });
        props.setErrors({...props.errors,error1:EMPTY})
    }
    const setLastName = (e) => {
        props.setEditUserData({ ...props.editUserData, lastName: e });
        props.setErrors({...props.errors,error2:EMPTY})
    }
    const setEmail = (e) => {
        props.setEditUserData({ ...props.editUserData, email: e });
        props.setErrors({...props.errors,error3:EMPTY})

    }
    return (
        <>
            <OEIInput value={props.editUserData.firstName} editUserData={props.editUserData} setValue={setFirstName} name='firstName' label={FIRSTNAME} errorMessage={props.errors.error1} showError='false'></OEIInput>
            <OEIInput value={props.editUserData.lastName} editUserData={props.editUserData} setValue={setLastName} name='lastName' label={LASTNAME} errorMessage={props.errors.error2} ></OEIInput>
            <OEIInput value={props.editUserData.email} editUserData={props.editUserData} setValue={setEmail} name='email' label='Email' errorMessage={props.errors.error3} ></OEIInput>
       <OEICheckBox></OEICheckBox>

        </>
    )
}

